import { Component, OnInit, ViewChild } from "@angular/core";
import { MatButtonToggleChange } from "@angular/material/button-toggle";
import { Observable, finalize, map } from "rxjs";
import { GenericWithSlug } from "src/app/interfaces/generic.interface";
import { PermissionsService } from "src/app/services/permissions.service";
import { environment } from "src/environments/environment";
import { helper } from "src/environments/helper";
import { BordeoruService } from "./bordeoru.service";
import { formatDate } from "@angular/common";
import { MatDialog } from "@angular/material/dialog";
import { DialogService } from "src/app/utils/dialog.service";
import Swal from "sweetalert2";
import { saveAs } from "file-saver";
import { AddBorderouComponent } from "./add-borderou/add-borderou.component";
import { AppFilesService } from "src/app/services/app-files.service";
import { AcordComercializareComponent } from "./acord-comercializare/acord-comercializare.component";
import { AcordFunctionareComponent } from "./acord-functionare/acord-functionare.component";
import { AcordTemporarTeraseComponent } from "./acord-temporar-terase/acord-temporar-terase.component";
import { AcordTemporarToateComponent } from "./acord-temporar-toate/acord-temporar-toate.component";
import { AcordTeraseSezoniereComponent } from "./acord-terase-sezoniere/acord-terase-sezoniere.component";
import { AlimentatiePublicaComponent } from "./alimentatie-publica/alimentatie-publica.component";
import { AutorizatieTargPiataComponent } from "./autorizatie-targ-piata/autorizatie-targ-piata.component";
import { ModificareAvizOrarComponent } from "./modificare-aviz-orar/modificare-aviz-orar.component";
import { PrelungireAcorduriFunctionareComponent } from "./prelungire-acorduri-functionare/prelungire-acorduri-functionare.component";
import { RecreativeComponent } from "./recreative/recreative.component";
import { ToateTabelBorderouComponent } from "./toate-tabel-borderou/toate-tabel-borderou.component";
import { NotificationService } from "src/app/services/notification.service";

@Component({
    selector: "app-borderou",
    templateUrl: "./borderou.component.html",
    styleUrls: ["./borderou.component.scss"],
})
export class BorderouComponent implements OnInit {
    @ViewChild(AcordComercializareComponent) appAcordComercializare!: AcordComercializareComponent;
    @ViewChild(AcordFunctionareComponent) appAcordFunctionare!: AcordFunctionareComponent;
    @ViewChild(AcordTemporarTeraseComponent) appAcordTemporarTerase!: AcordTemporarTeraseComponent;
    @ViewChild(AcordTemporarToateComponent) appAcordTemporarToate!: AcordTemporarToateComponent;
    @ViewChild(AcordTeraseSezoniereComponent) appAcordTeraseSezoniere!: AcordTeraseSezoniereComponent;
    @ViewChild(AlimentatiePublicaComponent) appAlimentatiePublica!: AlimentatiePublicaComponent;
    @ViewChild(AutorizatieTargPiataComponent) appAutorizatieTargPiata!: AutorizatieTargPiataComponent;
    @ViewChild(ModificareAvizOrarComponent) appModificareAvizOrar!: ModificareAvizOrarComponent;
    @ViewChild(PrelungireAcorduriFunctionareComponent) appPrelungireAcorduriFunctionare!: PrelungireAcorduriFunctionareComponent;
    @ViewChild(RecreativeComponent) appRecreative!: RecreativeComponent;
    @ViewChild(ToateTabelBorderouComponent) appToateTabelBorderou!: ToateTabelBorderouComponent;

    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    isLoading = false;
    dateBorderou: Date = new Date();
    formattedDate: string = formatDate(this.dateBorderou, 'yyyy-MM-dd', 'en-US');
    dataTableParams: any = {};
    current_info: any = null;

    defaultParameter: { id: string, name: string, slug: string } = {
        id: "-1",
        name: "Toate",
        slug: 'toate'
    };

    // Info for conditional assign and change status from DT
    selectedTabelBorderou = this.defaultParameter;

    borderou$!: Observable<GenericWithSlug[]>;

    // borderou_id: number = -1;
    // List of ids on which we render the Add button

    // allowedBorderouIds = [-1, 1, 2, 3, 4, 5, 6, 7, 8];
    // selectedBorderouId!: number;

    borderou_slug: string = '';
    borderou_name: string = '';

    allowedBorderouSlugs = [
        'modificare_aviz_orar',
        'acord_temporar',
        'alimentatie_publica',
        'recreative',
        'prelungire_acord_functionare',
        'acord_temporar_terase',
        'autorizatii_piata_targ',
        'acord_functionare',
        'acord_comercializare',
        'terase_sezoniere'
    ]

    isAllowedBorderou(): boolean {
        return (
            this.allowedBorderouSlugs.includes(this.borderou_slug)
        );
    }

    updateDataTableParams() {
        this.dataTableParams.formattedDate = this.formattedDate;
    }

    dtLink =
        environment.interop.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.borderou
            .borderouList;

    constructor(
        private borderouService: BordeoruService,
        private permissionsService: PermissionsService,
        private dialog: MatDialog,
        private dialogService: DialogService,
        private appFilesService: AppFilesService,
        private notificationService: NotificationService,
    ) { }

    ngOnInit(): void {
        this.loadBorderou();
        this.updateDataTableParams();
    }

    loadBorderou() {
        this.borderou$ = this.borderouService
            .getBorderouActive()
            .pipe(map((results: any) => [this.defaultParameter, ...results]));
    }

    onTableChange(event: MatButtonToggleChange) {
        this.selectedTabelBorderou = event.value;
        this.borderou_slug = event.value.slug;
        this.borderou_name = event.value.name;

        if (this.isAllowedBorderou()) {
            this.getInfo();
        }
    }

    rerenderChildDT(borderouSlug: string, paginate = false) {
        switch (borderouSlug) {
            case 'acord_comercializare':
                this.appAcordComercializare.rerenderDT(paginate);
                break;
            case 'acord_functionare':
                this.appAcordFunctionare.rerenderDT(paginate);
                break;
            case 'acord_temporar_terase':
                this.appAcordTemporarTerase.rerenderDT(paginate);
                break;
            case 'acord_temporar':
                this.appAcordTemporarToate.rerenderDT(paginate);
                break;
            case 'terase_sezoniere':
                this.appAcordTeraseSezoniere.rerenderDT(paginate);
                break;
            case 'alimentatie_publica':
                this.appAlimentatiePublica.rerenderDT(paginate);
                break;
            case 'autorizatii_piata_targ':
                this.appAutorizatieTargPiata.rerenderDT(paginate);
                break;
            case 'modificare_aviz_orar':
                this.appModificareAvizOrar.rerenderDT(paginate);
                break;
            case 'prelungire_acord_functionare':
                this.appPrelungireAcorduriFunctionare.rerenderDT(paginate);
                break;
            case 'recreative':
                this.appRecreative.rerenderDT(paginate);
                break;
            default:
                this.appToateTabelBorderou.rerenderDT(paginate);
                break;
        }
    }

    reset() {
        if (this.isAllowedBorderou()) {
            this.getInfo();
        }
        this.rerenderChildDT(this.borderou_slug);
    }

    onDateChange(event: any) {
        this.formattedDate = formatDate(event.value, 'yyyy-MM-dd', 'en-US');
        this.dataTableParams.formattedDate = this.formattedDate;

        this.getInfo();
        this.rerenderChildDT(this.borderou_slug, true);
    }

    getInfo() {
        this.borderouService
            .infoBorderou(this.borderou_slug, this.formattedDate)
            .subscribe(response => {
                this.current_info = response;
            })
    }

    print() {
        this.isLoading = true;
        const data = { date: this.formattedDate };
        this.borderouService.print(data, this.borderou_slug)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (response) => {
                    // Assuming the file is a PDF. If not, replace 'application/pdf' with the correct mime type.
                    this.isLoading = false;
                    const blob = new Blob([response], { type: "application/pdf" });
                    const filename = `print_${this.borderou_slug}_${this.formattedDate}.pdf`;
                    saveAs(blob, filename);

                    this.getInfo();
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                }
            });
    }

    openAddDialog() {
        const dialogRef = this.dialog.open(AddBorderouComponent, {
            ...this.dialogService.getDialogConfig(),
            data: {
                type_slug: this.borderou_slug,
                name: this.borderou_name,
                date: this.formattedDate
            },
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: "Borderou adăugat cu succes!",
                    icon: "success",
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });

                this.getInfo();
            }
        });
    }

    downloadBorderouInfo(id: number) {
        const urlDownload = this.borderouService.downloadBorderouFileURL + id;
        this.isLoading = true;
        this.appFilesService.downloadFile(urlDownload)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            })
    }
}
